import type { ReactNode } from 'react'
import { SiteFooter, SkipLink, Wordmark } from '@/components/marketing/SiteChrome'
import { cn } from '@/lib/utils'

/** Frame for customer-facing product screens. Reuses the marketing wordmark and footer (support email, legal links). */
export function AppShell({ children, wide = false }: { children: ReactNode; wide?: boolean }) {
  const width = wide ? 'max-w-7xl' : 'max-w-5xl'
  return (
    <div className="flex min-h-dvh flex-col bg-background text-foreground">
      <SkipLink />
      <header className="border-b border-border">
        <div className={cn('mx-auto flex h-16 items-center px-4', width)}>
          <Wordmark />
        </div>
      </header>
      <main id="main" className={cn('mx-auto w-full flex-1 px-4 py-8', width)}>
        {children}
      </main>
      <SiteFooter width={width} />
    </div>
  )
}
